import './Subiecte.css';

export default function TesteAntrenament2020() {
    const teste = Array.from({ length: 20 }, (_, i) => i + 1);

    return (
        <div className="container my-4">
            <h2 className="fw-bold mb-4 subjectTitle">Teste Antrenament 2020</h2>
            {teste.map((num) => (
                <div key={num} className="mb-4">
                    <h5>{num}. <strong>Testul {num}</strong></h5>
                    <ul className="ms-3">
                        <li>
                            <strong>Specializarea Matematică-Informatică:</strong>
                            <ul className="ms-3">
                                <li>
                                    <a href={`/subiecte/2020/SubiectTestAntrenament${num}-2020MIC.pdf`} target="_blank" rel="noreferrer">Subiect C/C++</a> |{' '}
                                    <a href={`/subiecte/2020/SubiectTestAntrenament${num}-2020MIPascal.pdf`} target="_blank" rel="noreferrer">Subiect Pascal</a>
                                </li>
                                <li>
                                    <a href={`/subiecte/2020/BaremTestAntrenament${num}-2020MI.pdf`} target="_blank" rel="noreferrer">Barem</a>
                                </li>
                            </ul>
                        </li>
                        <li>
                            <strong>Specializarea Științele-Naturii:</strong>
                            <ul className="ms-3">
                                <li>
                                    <a href={`/subiecte/2020/SubiectTestAntrenament${num}-2020SNC.pdf`} target="_blank" rel="noreferrer">Subiect C/C++</a> |{' '}
                                    <a href={`/subiecte/2020/SubiectTestAntrenament${num}-2020SNPascal.pdf`} target="_blank" rel="noreferrer">Subiect Pascal</a>
                                </li>
                                <li>
                                    <a href={`/subiecte/2020/BaremTestAntrenament${num}-2020SN.pdf`} target="_blank" rel="noreferrer">Barem</a>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </div>
            ))}
        </div>
    );
}